export const FETCH_DATBIM_CLASSES = 'FETCH_DATBIM_CLASSES';
export const FETCH_DATBIM_CATEGORIES = 'FETCH_DATBIM_CATEGORIES';
